import React from 'react';

const UserCell = ({chat, selectedSectionId, onSelectUser}) => {
    return (
        <div className={`chat-user-item ${selectedSectionId === chat.id ? 'active' : ''}`} onClick={() => {
            onSelectUser(chat);
        }}>
            <div className="chat-user-row row">
                <div className="chat-avatar col-xl-2 col-3">
                    <div className="chat-avatar-mode">
                        <img src={chat.thumb} className="rounded-circle size-50" alt={chat.name}/>
                        <span className={`chat-mode ${chat.status}`}/>
                    </div>
                </div>

                <div className="chat-info col-xl-8 col-6">
                    <span className="name h4">{chat.name}</span>
                    <div className="chat-info-des">{chat.lastMessage.substring(0, 30) + "..."}</div>
                </div>

                <div className="chat-date col-xl-2 col-3">
                    <div className="last-message-time">{chat.lastMessageTime}</div>

                    <div className="bg-primary rounded-circle badge text-white">{chat.unreadMessage}</div>

                </div>
            </div>
        </div>
    )
};

export default UserCell;


// WEBPACK FOOTER //
// ./components/chatPanel/ChatUserList/ChatUserList/UserCell/index.js